import { useState } from "react";
import { Phone, Mail, MessageCircle, X, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

const FloatingContact = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3 pointer-events-none">
      {/* Contact Options */}
      <div
        className={`flex flex-col gap-2 transition-all duration-300 ${
          isOpen ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4"
        }`}
      >
        {/* SMS */}
        <a
          href="sms:+16317070672?body=I'd%20Like%20To%20Get%20Started%20on%20my%20Own%20Personal%20Website"
          className="flex items-center gap-3 bg-card border border-border rounded-full pl-4 pr-2 py-2 shadow-lg hover:border-primary hover:shadow-[0_0_20px_hsl(var(--primary)/0.3)] transition-all duration-300 group"
        >
          <span className="text-sm font-medium text-foreground group-hover:text-primary transition-colors">
            Text Me
          </span>
          <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
            <MessageSquare size={18} className="text-primary-foreground" />
          </div>
        </a>

        {/* Phone */}
        <a
          href="tel:+16317070672"
          className="flex items-center gap-3 bg-card border border-border rounded-full pl-4 pr-2 py-2 shadow-lg hover:border-primary hover:shadow-[0_0_20px_hsl(var(--primary)/0.3)] transition-all duration-300 group"
        >
          <span className="text-sm font-medium text-foreground group-hover:text-primary transition-colors">
            Call Now
          </span>
          <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
            <Phone size={18} className="text-primary-foreground" />
          </div>
        </a>

        {/* WhatsApp */}
        <a
          href="https://wa.me/16317070672"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 bg-card border border-border rounded-full pl-4 pr-2 py-2 shadow-lg hover:border-green-500 hover:shadow-[0_0_20px_rgba(34,197,94,0.3)] transition-all duration-300 group"
        >
          <span className="text-sm font-medium text-foreground group-hover:text-green-500 transition-colors">
            WhatsApp
          </span>
          <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
            <MessageCircle size={18} className="text-white" />
          </div>
        </a>

        {/* Email */}
        <a
          href="mailto:aj@waveandwirewebdesigns.com?subject=I'd%20Like%20To%20Get%20Started%20on%20my%20Own%20Personal%20Website"
          className="flex items-center gap-3 bg-card border border-border rounded-full pl-4 pr-2 py-2 shadow-lg hover:border-primary hover:shadow-[0_0_20px_hsl(var(--primary)/0.3)] transition-all duration-300 group"
        >
          <span className="text-sm font-medium text-foreground group-hover:text-primary transition-colors">
            Email
          </span>
          <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
            <Mail size={18} className="text-primary-foreground" />
          </div>
        </a>
      </div>

      {/* Main Toggle Button */}
      <Button
        onClick={() => setIsOpen(!isOpen)}
        size="lg"
        aria-label={isOpen ? "Close contact menu" : "Open contact menu"}
        className={`w-14 h-14 rounded-full shadow-lg transition-all duration-300 hover:shadow-[0_0_30px_hsl(var(--primary)/0.5)] pointer-events-auto ${
          isOpen ? "bg-muted hover:bg-muted/80" : "bg-primary hover:bg-primary/90"
        }`}
      >
        {isOpen ? (
          <X size={24} className="text-foreground" />
        ) : (
          <MessageSquare size={24} className="text-primary-foreground" />
        )}
      </Button>
    </div>
  );
};

export default FloatingContact;
